var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouare1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5572 0.029129C19.9556 -0.293968 25.1998 2.28347 28.2332 6.71872C32.1773 12.4831 31.7881 20.3622 27.1462 25.5979L32.809 31.2668C33.4553 32.3095 32.2508 33.4844 31.2299 32.7721L25.5964 27.1399C19.2065 32.8162 9.10744 31.9864 3.64294 25.451C-4.53178 15.6847 1.88754 0.792814 14.5572 0.029129ZM14.6307 2.22472C4.84013 2.87092 -0.969572 13.6066 4.00283 22.154C9.40857 31.443 23.1506 30.7381 27.5722 20.9423C31.6779 11.8369 24.5682 1.57119 14.6233 2.22472H14.6307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1247 11.5656C20.5947 11.4848 22.2253 11.4921 22.71 11.5582C23.1948 11.6243 23.5914 12.0502 23.6428 12.5496C23.6942 13.0489 23.7089 14.5763 23.6281 15.0756C23.4592 16.0816 22.0784 16.2432 21.5496 15.406L18.5309 18.8426C18.1489 19.2465 17.5467 19.4007 17.0546 19.0776L12.398 15.4134L8.85048 18.6444C7.8369 19.2832 6.64705 18.0936 7.35949 17.0803C8.63748 15.9201 9.84202 14.6497 11.142 13.5042C11.7076 13.0048 12.163 12.5642 12.9489 13.0048L17.4953 16.6323L19.9998 13.8493C19.6252 13.4601 19.2213 13.2178 19.236 12.6156C19.2507 12.1237 19.6326 11.6464 20.1173 11.5656H20.1247Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouare1);
export default __webpack_public_path__ + "static/media/youare1.4b06a479d3513f78c822d99a0af92fae.svg";
export { ForwardRef as ReactComponent };